import { useApplicationStore } from '@/stores/applicationStore';
import {computed} from "vue";

export const useButtonStyle = computed(() => {
  let output = {};
  const applicationStore = useApplicationStore();
  if (applicationStore?.appStyle?.button_background_color && applicationStore?.appStyle?.button_text_color) {
    output.style = {'background-color': applicationStore.appStyle.button_background_color, 'color': applicationStore.appStyle.button_text_color};
  }
  return output;
});